import { throttle, debounce } from "theme";

if (!customElements.get("sticky-collection-toolbar")) {
    class StickyCollectionToolbar extends HTMLElement {
        constructor() {
            super();
            this.mainToolbar = document.querySelector(
                ".collection__toolbar:not(.collection-toolbar--sticky .collection__toolbar)"
            );
            this.pageFooter = document.querySelector(
                ".shopify-section-group-footer-group"
            );
        }

        connectedCallback() {
            if (!this.mainToolbar) return;
            document.addEventListener(
                "scroll",
                throttle(this.handleScroll.bind(this), 50).bind(this)
            );
            this.handleSmallPage();
            window.addEventListener(
                "resize",
                debounce(this.handleSmallPage.bind(this), 100).bind(this)
            );
            document.addEventListener("layout:change", this.handleSmallPage.bind(this));
        }

        handleSmallPage() {
            if (!this.pageFooter) return;
            const mainToolbarTop = this.mainToolbar.offsetTop;
            const mainToolbarHeight = this.mainToolbar.offsetHeight;
            const mainToolbarBottom = mainToolbarTop + mainToolbarHeight;

            const footerTop = this.pageFooter.offsetTop;
            const spaceBelowToolbar = footerTop - mainToolbarBottom;

            if (spaceBelowToolbar < window.innerHeight) {
                this.classList.remove("inline-flex");
            } else {
                this.classList.add("inline-flex");
            }
        }

        handleScroll() {
            if (!this.mainToolbar || !this.pageFooter) return;
            const mainToolbarRect =
                this.mainToolbar.getBoundingClientRect();
            const footerRect = this.pageFooter.getBoundingClientRect();
            this.classList.toggle("is-visible", mainToolbarRect.bottom < 0 && footerRect.top > window.innerHeight);
        }
    }

    customElements.define("sticky-collection-toolbar", StickyCollectionToolbar);
}
